<template>
	<q-layout :class="$q.platform.is.mobile ? 'bg-white' : ''" view="hHh Lpr fff">
		<q-page-container :class="$q.platform.is.mobile && $q.platform.is.capacitor ? 'q-pt-xl' : ''">
			<router-view />
		</q-page-container>

		<accept-cookies-policy-new v-if="cookies_type !== 'onetrust' && cookies_type !== undefined"/>
	</q-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import { createMetaMixin } from 'quasar'
import AcceptCookiesPolicyNew from 'components/utils/AcceptCookiesPolicyNew'

export default {
	name: 'LayoutOpenDesktop',

	i18nOptions: { namespaces: ['custom'] },

	data() {
		return {
			meta: {
				description: this.$t('platform_meta_description'),
			},
		}
	},

	mixins: [
		createMetaMixin(function () {
			return {
				meta: {
					description: { name: 'description', content: this.meta.description },
				},
			}
		}),
	],

	components: {
		'accept-cookies-policy-new': AcceptCookiesPolicyNew,
	},

	computed: {
		...mapGetters({
			id_user_language_selected: 'common/id_user_language_selected',
			languages: 'params/languages',
			user_language_selected: 'common/user_language_selected',
			cookies_type: 'params/cookies_type',
		}),
	},

	methods: {
		getParams() {
			this.$q.loading.show()

			this.$axios
				.get('/clients/config/')
				.then((response) => {
					this.$store.dispatch('params/SET_PARAMS', [
						response.data.login,
						response.data.clients,
						response.data.self_register,
						response.data.user_profile,
						response.data.languages,
						response.data.qty_login_attempts,
						response.data.layout,
					])
					if (!response.data.login.use_portfolio_page) {
						let nav_language = navigator.language.split('-')[0]

						if (nav_language) {
							const user_language_id = response.data.languages.find(
								(obj) => obj.code.split('-')[0] === nav_language
							)
							let language = this.$getLanguage(
								response.data.languages,
								this.user_language_selected
									? response.data.languages.find(
											(obj) => obj.code.split('-')[0] === this.user_language_selected.split('-')[0]
									  ).id
									: user_language_id?.id ? user_language_id.id : 1 
							)

							if (language?.code)
								this.$changeWaLocal(language.code === 'pt-br' ? 'br-pt' : language.code)

							if (language) {
								this.$store.dispatch('common/SET_LANGUAGE', [language.id])
							} else {
								this.$store.dispatch('common/SET_LANGUAGE', [
									response.data.login.default_language_id,
								])
							}
						} else {
							this.$store.dispatch('common/SET_LANGUAGE', [response.data.login.default_language_id])
						}
					} else {
						if (!this.user_language_selected) {
							this.$store.dispatch('common/SET_LANGUAGE', [response.data.login.default_language_id])
						}
					}
					if (response.data.login.use_portfolio_page && this.$route.name === 'login')
						this.$router.replace({ name: 'portfolio' })
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},
	},

	watch: {
		id_user_language_selected: function (val) {
			let language = this.$getLanguage(this.languages, this.id_user_language_selected)
			if (language) {
				this.$i18n.locale = language.code
				this.$store.dispatch('common/SET_LANGUAGE_CODE', [language.code])
			}
			document.title = this.$i18n.t('project_name')
		},
	},

	created() {
		this.getParams()
	},
}
</script>

<style></style>
